/** Number display formatting shared by quote, order and cart screens. */

import { Locale } from "@ryerson/frontend.common";

/**
 * Formats a number for display with US separators (`en-us`) whatever the user's language, with
 * at least two decimals (and the `toLocaleString` default maximum of three). Non-numeric input
 * gives `"NaN"`. Used for weights and quantities.
 */
export const formatNumber = (number: any) =>
	Number(number).toLocaleString(Locale.us, {
		minimumFractionDigits: 2,
	});
